<template>
    <div class="flex flex-wrap items-center justify-center flex-col">
        <h1 id="question" class="text-lg text-center text-black bg-gray-500 rounded p-3 mb-2 border-b border-gray-700 inline-block">
            <i aria-hidden="true" class="material-icons align-middle">info</i>
            {{ question.attributes.choices.top }}
        </h1>

        <h2>
            {{ question.attributes.choices.note }}
        </h2>

        <!-- This is if it's a choose_one Display Type -->
        <ul v-if="question.attributes.choices.display_type == 'choose_one'">
            <li v-for="(choice, index) in question.attributes.choices.options">
                <input type="hidden" name="saveChooseOne" :value="choice.save">

                <button type="button"
                    :disabled="saving"
                    :style="saving ? { opacity: '70%' } : {}"
                    @click="answer(choice.save)"
                    class="px-5 py-2"
                >
                    <i aria-hidden="true" class="material-icons align-middle">check</i> {{ choice.display }}
                </button>
            </li>
        </ul>

        <div v-if="question.attributes.choices.display_type == 'choose_one_pole'"
            class="flex items-start w-full md:w-1/2"
        >
            <div class="flex-1 rounded-md bg-gray-900 flex flex-col items-center mr-3 pt-2 pb-6">
                <h3 id="columnLabelLeft"
                    class="mb-5"
                >
                    {{ question.attributes.choices.pole.A }}
                </h3>

                <div class="flex flex-col items-center" role="group" aria-labelledby="question columnLabelLeft">
                    <button type="button"
                        class="transform scale-125 px-5 mb-6"
                        :disabled="saving"
                        :style="saving ? { opacity: '70%' } : {}"
                        @click="answer(question.attributes.choices.options[1].save)"
                    >
                        {{ question.attributes.choices.options[1].display }}
                    </button>

                    <button type="button"
                        class="px-5 mb-4"
                        :disabled="saving"
                        :style="saving ? { opacity: '70%' } : {}"
                        @click="answer(question.attributes.choices.options[2].save)"
                    >
                        {{ question.attributes.choices.options[2].display }}
                    </button>

                    <button type="button"
                        class="transform scale-90 px-2"
                        :disabled="saving"
                        :style="saving ? { opacity: '70%' } : {}"
                        @click="answer(question.attributes.choices.options[3].save)"
                    >
                        {{ question.attributes.choices.options[3].display }}
                    </button>
                </div>
            </div>

            <div class="flex-1 rounded-md bg-gray-900 flex flex-col items-center ml-3 pt-2 pb-6">
                <h3 id="columnLabelRight"
                    class="mb-5"
                >
                    {{ question.attributes.choices.pole.B }}
                </h3>

                <div class="flex flex-col items-center" role="group" aria-labelledby="question columnLabelRight">
                    <button type="button"
                        class="transform scale-125 px-5 mb-6"
                        :disabled="saving"
                        :style="saving ? { opacity: '70%' } : {}"
                        @click="answer(question.attributes.choices.options[6].save)"
                    >
                        {{ question.attributes.choices.options[6].display }}
                    </button>

                    <button type="button"
                        class="px-5 mb-4"
                        :disabled="saving"
                        :style="saving ? { opacity: '70%' } : {}"
                        @click="answer(question.attributes.choices.options[5].save)"
                    >
                        {{ question.attributes.choices.options[2].display }}
                    </button>

                    <button type="button"
                        class="transform scale-90 px-2"
                        :disabled="saving"
                        :style="saving ? { opacity: '70%' } : {}"
                        @click="answer(question.attributes.choices.options[4].save)"
                    >
                        {{ question.attributes.choices.options[3].display }}
                    </button>
                </div>
            </div>
        </div>

        <div class="text-sm text-gray-300 py-8">
            {{ $t('Select an option to proceed to the next question.') }}
        </div>
    </div>
</template>

<script>
import VTooltip from 'v-tooltip';

export default {
    props: {
        question: {},
        saving: { default: false },
    },

    methods: {
        answer(value) {
            this.$emit('answered', value);
        },
    },
}
</script>
